module.exports = __webpack_public_path__ + "static/media/background_404.d340ad9c.jpg";